// ----------------------------------------------------------------------------
// PERFORMANCE UTILITIES
// ----------------------------------------------------------------------------

// Libraries
// -------------------------------------
var respimg          = require('lazysizes/plugins/respimg/ls.respimg.min');
var parentFit        = require('lazysizes/plugins/parent-fit/ls.parent-fit.min');
var bgset            = require('lazysizes/plugins/bgset/ls.bgset.min');
var lazysizes        = require('lazysizes/lazysizes.min');


// Lazysizes
// -------------------------------------
module.exports = function() {
    window.lazySizesConfig = window.lazySizesConfig || {};
    window.lazySizesConfig.customMedia = {
        '--mobile': '(max-width: 500px)',
        '--tablet': '(max-width: 768px)',
        '--laptop': '(max-width: 1024px)',
        '--desktop': '(max-width: 1800px)'
    };
}
